import { fetchWithAuth } from './auth';
import { API_BASE } from '../config';

export async function apiGetExpenses(): Promise<any[]> {
    const res = await fetchWithAuth(`${API_BASE}/expense`);
    if (!res.ok) throw new Error(`Ошибка загрузки расходов: ${res.status}`);
    return res.json();
}

export async function apiCreateExpense(data: any): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/expense`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`Ошибка сохранения расхода: ${res.status}`);
}

export async function apiUpdateExpense(id: string, data: any): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/expense/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`Ошибка обновления расхода: ${res.status}`);
}

export async function apiDeleteExpense(id: string): Promise<void> {
    const res = await fetchWithAuth(`${API_BASE}/expense/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error(`Ошибка удаления расхода: ${res.status}`);
}
